

































































import Vue from 'vue';
import Component from 'vue-class-component';
import TitleMedium from '@/components/title/medium.vue';
import TextBody from '@/components/text/body.vue';

@Component({
  components: {
    TitleMedium,
    TextBody,
  },
  props: ['column'],
})
export default class ListVertical extends Vue {}
